<template>
    <div class="radio-filter">
        <!-- Titlen tegnes af indpakningen, som også bærer sammenklapningen. -->

        <!--
            Enkeltvalg. Forskellen fra select er ikke kosmetisk: her kan man kun
            vælge én værdi, og det er den rigtige kontrol når værdierne udelukker
            hinanden. En vare er enten ny eller brugt, den er ikke begge dele, og
            en afkrydsningsliste der lader dig vælge begge lover et resultat der
            ikke findes.
        -->
        <div class="radio-filter__valg">
            <label class="radio-filter__linje">
                <input
                    type="radio"
                    class="form-check-input"
                    :name="`radio-${filter.id}`"
                    value=""
                    :checked="valgt === ''"
                    @change="vaelg('')"
                />
                <span class="radio-filter__etiket">Alle</span>
            </label>

            <label
                v-for="value in filter.values"
                :key="value.filter_value_slug"
                class="radio-filter__linje"
            >
                <input
                    type="radio"
                    class="form-check-input"
                    :name="`radio-${filter.id}`"
                    :value="value.filter_value_slug"
                    :checked="valgt === value.filter_value_slug"
                    @change="vaelg(value.filter_value_slug)"
                />
                <span class="radio-filter__etiket">{{ value.displayed_value }}</span>
            </label>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { alleAktiveFiltre } from '@/Components/FilterManager.vue';

const emit = defineEmits(['filterUpdated']);
const props = defineProps(['filter', 'urlParams', 'categoryName']);

function fraUrl() {
    if (!props.urlParams) return '';

    return props.urlParams.get(String(props.filter.id)) || '';
}

const valgt = ref(fraUrl());

// Bruger man browserens tilbage-knap, skal knappen følge med adressen.
watch(() => (props.urlParams ? props.urlParams.get(String(props.filter.id)) : ''), (ny) => {
    valgt.value = ny || '';
});

function vaelg(slug) {
    valgt.value = slug;

    // Tom værdi betyder "alle", og så skal mit eget filter ud af adressen.
    // De øvrige skal blive stående, derfor sendes hele listen med.
    emit('filterUpdated', alleAktiveFiltre(props.urlParams, props.filter.id, slug));
}
</script>

<style scoped>
.radio-filter__title {
    font-weight: 600;
    color: var(--pc-text-primary);
    margin-bottom: 6px;
}

.radio-filter__valg {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.radio-filter__linje {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.radio-filter__etiket {
    color: var(--pc-text-secondary);
    font-size: var(--pc-text-sm, 0.875rem);
}

.radio-filter__linje:hover .radio-filter__etiket {
    color: var(--pc-text-primary);
}
</style>
